import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/apiClient";
import { StatusBadge } from "../components/StatusBadge";
import { Button } from "../components/ui/button";
import { WarningDiamond, ArrowsClockwise, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Alerts() {
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);
  const [scanning, setScanning] = useState(false);
  const load = () => api.get("/alerts?resolved=false").then(({ data }) => setAlerts(data));
  useEffect(() => { load(); }, []);

  const scan = async () => {
    setScanning(true);
    try { const { data } = await api.post("/alerts/scan"); toast.success(`Scanned ${data.scanned} tyres · ${data.new_alerts} new alerts`); load(); }
    finally { setScanning(false); }
  };
  const resolve = async (id) => { await api.post(`/alerts/${id}/resolve`); load(); };

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <div className="overline text-amber-500 flex items-center gap-2"><WarningDiamond size={14} /> Alert Centre</div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">Alerts & Notifications</h1>
        </div>
        <Button data-testid="scan-alerts-btn" onClick={scan} disabled={scanning} className="bg-amber-500 font-bold text-zinc-950 hover:bg-amber-400">
          <ArrowsClockwise size={16} weight="bold" className="mr-1" /> {scanning ? "Scanning…" : "Run Scan"}
        </Button>
      </div>

      <div className="space-y-2">
        {alerts.map((a) => (
          <div key={a.id} data-testid={`alert-${a.id}`} className="flex items-center justify-between rounded-sm border border-zinc-800 bg-zinc-900 p-4">
            <div className="flex items-center gap-3">
              <StatusBadge status={a.severity} />
              <div>
                <div className="text-sm font-semibold">{a.message}</div>
                <div className="overline text-zinc-500">{a.category?.replace(/_/g, " ")} · {new Date(a.created_at).toLocaleDateString()}</div>
              </div>
            </div>
            <div className="flex gap-2">
              {a.tyre_id && <Button size="sm" variant="outline" onClick={() => navigate(`/tyres/${a.tyre_id}`)}>View</Button>}
              <Button size="sm" variant="outline" onClick={() => resolve(a.id)} data-testid={`resolve-${a.id}`}><CheckCircle size={15} className="mr-1" />Resolve</Button>
            </div>
          </div>
        ))}
        {alerts.length === 0 && (
          <div className="rounded-sm border border-dashed border-zinc-800 p-12 text-center text-sm text-zinc-500">
            No open alerts. Run a scan to evaluate tyre health.
          </div>
        )}
      </div>
    </div>
  );
}
